
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[treatment]",
      function () {
        return require("private-next-pages/[treatment].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[treatment]"])
      });
    }
  